// extracted by mini-css-extract-plugin
export default {"gas":"Tx_gas__h9JJV","select":"Tx_select__UlQpT","icon":"Tx_icon__vbB8F","hidden":"Tx_hidden__rAlXf"};